/**
 * PERSON CHANNEL LOOKUP — Adapter view-side per combobox dual-field.
 *
 * Clone esatto di personSourceLookup. Wrapper su `personChannelApi.getAll`
 * che mappa `PersonChannel[]` a `LookupOption[]` (`{id, label}`) — il
 * contratto dei combobox del progetto (DualFieldAutocomplete, EditableField
 * variant `lookup` / `lookupFreeSolo`).
 *
 * Centralizza il fetcher usato da PersonFormBody e PersonDetail (inline-edit
 * Canale): pageSize=20 e search-on-empty come convenzioni concordate. Errori
 * → array vuoto silenzioso.
 */

import type { LookupOption } from '../../components/EditableField';
import { personChannelApi } from './personChannelApi';

export async function searchPersonChannelsAsLookup(
  groupId: number,
  query: string,
): Promise<LookupOption[]> {
  try {
    const page = await personChannelApi.getAll(groupId, {
      search: query || undefined,
      pageSize: 20,
    });
    return page.items.map((c) => ({ id: c.personChannelId, label: c.name }));
  } catch {
    return [];
  }
}
